<template lang="pug">
  main
    Loader(v-show="isLoading")
    .container
      .columns.is-vcentered
        .column.is-8
          h1.is-size-5
            | Nueva Categoría&nbsp
            a.button.is-dark.is-rounded.is-small(@click="cerrarTipo")
              i.fas.fa-times
              | &nbsp Cerrar
      .columns(v-show="verNotificacion")
        .notification.is-danger
          span  El nombre de la categoría es requerido.
      .columns
        .column.is-12
          bulma-accordion
            bulma-accordion-item
              p.title.is-4.has-text-weight-normal(slot='title')
                | Datos Categoría
              i.material-icons(slot='icon') more_vert
              .high(slot='content')
                .columns.card-row.is-vcentered
                  .column.is-4
                    .field
                      .control
                        input.input.is-primary(
                          type='text', 
                          placeholder='Nombre de la Categoría',
                          v-model="nombre",
                        )
                  .column.is-3
                    .columns.is-vcentered
                      input#invI.is-checkradio.is-black(type='radio', value='i' v-model='area')
                      label.is-size-6(for='invI') Inst.
                      input#invS.is-checkradio.is-black(type='radio', value='s' v-model='area')
                      label.is-size-6(for='invS') Sist.
                      input#invA.is-checkradio.is-black(type='radio', value='a' v-model='area')
                      label.is-size-6(for='invA') Admón.
                .columns.card-row.is-vcentered
                  .column.is-3
                    .field
                      input#tipoServ.is-checkradio(type='checkbox' v-model='isServicio')
                      label.is-size-6(for='tipoServ') Servicio
                  .column.is-3
                    .field
                      input#tipoCons.is-checkradio(type='checkbox' v-model='isConsumible')
                      label.is-size-6(for='tipoCons') Consumible
                  .column.is-3
                    .field
                      .select.is-primary
                        select(v-model="tipo")
                          option(v-for="t in tipos" :key="t.id" :value="t.id") {{ t.nombre }}
      .columns
        .column.is-12
          bulma-accordion
            bulma-accordion-item
              p.title.is-4.has-text-weight-normal(slot='title')
                | Datos Responsiva
              i.material-icons(slot='icon') more_vert
              .high(slot='content')
                .columns.card-row 
                  input#respNA.is-checkradio.is-black(type='radio', value='0' v-model='catResp')
                  label.is-size-6(for='respNA') N/A
                  input#respC.is-checkradio.is-black(type='radio', value='1' v-model='catResp')
                  label.is-size-6(for='respC') Cómputo
                  input#respCom.is-checkradio.is-black(type='radio', value='2' v-model='catResp')
                  label.is-size-6(for='respCom') Comunicaciones
                  input#respE.is-checkradio.is-black(type='radio', value='3' v-model='catResp')
                  label.is-size-6(for='respE') Efectivale
                  input#respT.is-checkradio.is-black(type='radio', value='4' v-model='catResp')
                  label.is-size-6(for='respT') Tag
                  input#respV.is-checkradio.is-black(type='radio', value='5' v-model='catResp')
                  label.is-size-6(for='respV') Vehículos
      .columns.is-vcentered
        .column.is-offset-4.is-4
          a.button.is-block.is-black(@click="checkForm") Guardar Categoría
      .columns.column-blanco
</template>

<script>
import Loader from '../shared/Loader.vue'
import mySwitch from '@/components/inventario_Componentes/shared/SwitchArea.vue'
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
import InventarioServices from '../../services/inventario/inventario'

export default {
  name: 'NewTipo',
  components: { Loader, mySwitch, BulmaAccordion, BulmaAccordionItem },
  data () {
    return {
      nombre: null,
      isLoading: false,
      area: 'i',
      isServicio: false,
      verConsumibles: true,
      catResp: '0',
      isConsumible: false,
      tipo: 0,
      verNotificacion: false,
      tipos: [
        { id: 0, nombre: 'N/A' },
        { id: 1, nombre: 'Transporte' },
        { id: 2, nombre: 'Comunicaciones' },
        { id: 3, nombre: 'Mobiliario' },
        { id: 4, nombre: 'Papelería' },
        { id: 5, nombre: 'Tags' },
        { id: 6, nombre: 'Efectivale' },
        { id: 7, nombre: 'Herramienta' },
        { id: 8, nombre: 'Maquinaria' },
        { id: 9, nombre: 'Refacciones' },
        { id: 10, nombre: 'Limpieza' },
        { id: 11, nombre: 'Pintura' },
        { id: 12, nombre: 'Seguridad' },
        { id: 13, nombre: 'Uniformes' },
        { id: 14, nombre: 'Enfermería' },
      ]
    }
  },
  watch: {
    isServicio() {
      if (this.isServicio) {
        this.isConsumible = false 
      }
    },
    isConsumible() {
      if (this.isConsumible) {
        this.isServicio = false 
      }
    },
  },
  methods: {
    cerrarTipo () {
      this.isServicio = false
      this.isConsumible = false
      this.$emit('closeTipo', false)
    },
    checkForm() {
      if (this.nombre) {
        this.saveTipo()
        this.verNotificacion = false
      } else {
        if (!this.nombre) {
          this.verNotificacion = true
        }
      }
    },
    saveTipo () {
      this.isLoading = true
      let id = Date.now()
      const serv = this.isServicio ? 1 : 0
      const cons = this.isConsumible ? 1 : 0
      
      InventarioServices.addCategoria(id, this.nombre, this.area, serv, cons, this.tipo, this.catResp)
        .then(res => {
          console.log(res)
          if (res.success) {
            this.nombre = ''
            this.isLoading = false
            this.displayToast(res.success ? 'toasted-primary': 'bubble', res.respuesta, res.success ? 'done' : 'ban', 'OK')
            this.cerrarTipo()
          }
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
        })
    },
    checarEstadoArea (est) {
      this.area = est;
    },

    displayToast(tema,text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: tema, 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    }
    
  }

}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/NewTipo.vue